{
  "dialog": {
    "createTitle": "Nueva organización",
    "description": "Crea una nueva organización para gestionar proyectos y miembros.",
    "name": "Nombre",
    "slug": "Identificador (slug)",
    "slugHint": "Solo letras minúsculas, números y guiones",
    "color": "Color",
    "cancel": "Cancelar",
    "submit": "Crear",
    "submitting": "Creando..."
  },
  "toast": {
    "created": "Organización creada correctamente",
    "error": "Ocurrió un error. Inténtalo de nuevo.",
    "updated": "Organización actualizada correctamente",
    "updateError": "Error al actualizar la organización. Inténtalo de nuevo.",
    "deleteError": "Error al eliminar la organización. Inténtalo de nuevo."
  },
  "errors": {
    "nameMin": "El nombre debe tener al menos 2 caracteres",
    "nameMax": "El nombre no puede exceder 50 caracteres",
    "slugMin": "El identificador debe tener al menos 2 caracteres",
    "slugMax": "El identificador no puede exceder 50 caracteres",
    "slugInvalid": "Solo letras minúsculas, números y guiones",
    "colorRequired": "Selecciona un color",
    "descriptionMax": "La descripción no puede exceder 500 caracteres",
    "websiteUrlInvalid": "Debe ser una URL válida (ej: https://ejemplo.com)"
  },
  "apiErrors": {
    "notFound": "La organización no fue encontrada",
    "slugAlreadyExists": "Ya existe una organización con este identificador",
    "invalidTier": "El plan seleccionado no es válido",
    "cannotDowngrade": "No es posible reducir el plan: el número de miembros supera el límite del nuevo plan",
    "cannotDelete": "Solo el propietario puede eliminar la organización",
    "createDefault": "No fue posible crear la organización",
    "updateDefault": "No fue posible actualizar la organización",
    "deleteDefault": "No fue posible eliminar la organización",
    "onboardingConflict": "Ya existe una organización con ese nombre",
    "onboardingDefault": "No fue posible completar el onboarding. Inténtalo de nuevo.",
    "avatarUploadDefault": "Error al subir el logo de la organización",
    "avatarDeleteDefault": "Error al eliminar el logo de la organización"
  }
}
